import { IOnboardingRepository } from '../../domain/repositories/IOnboardingRepository';
import { OnboardingProgressDTO } from '../dto/OnboardingProgressDTO';
import { OnboardingMapper } from '../mappers/OnboardingMapper';

/**
 * ResetOnboardingUseCase
 * Resets onboarding to initial state (for "Restart Onboarding" in settings)
 *
 * Business Logic:
 * - Clears all step completions
 * - Resets status to 'pending'
 * - Sets currentStepIndex to 0
 * - Clears startedAt, completedAt, skippedAt timestamps
 * - Returns reset progress DTO
 */
export class ResetOnboardingUseCase {
  constructor(private readonly repository: IOnboardingRepository) {}

  /**
   * Execute the use case
   *
   * @param userId - UUID of the user
   * @param role - User role ('director' | 'teacher' | 'student')
   * @returns Promise<OnboardingProgressDTO> - Reset progress
   */
  async execute(userId: string, role: string): Promise<OnboardingProgressDTO> {
    const progress = await this.repository.resetOnboarding(userId, role);
    return OnboardingMapper.progressToDTO(progress);
  }
}
